import Layout from '@/component/Layout/Layout'
import { useRoundPage } from './hooks/useRoundPage'
import ResultCard from '@/component/ResultCard'
import { useTranslation } from 'react-i18next'
import useLottoCardForLottoRoundPage from './hooks/useLottoCardForLottoRoundPage'
import { LottoRoundScreen } from '@/ui-components/screens/LottoRoundScreen'
import { trans } from '@/i18n/utils'
import gamePageStyles from '@/ui-components/pages/GamePage.module.css'

const LottoRoundsPage = () => {
  const { game, rounds, loading, error, gameTitle } = useRoundPage()
  const createLottoCardForLottoRoundPage = useLottoCardForLottoRoundPage()
  const { i18n } = useTranslation()
  if (error) {
    return <div>Error loading rounds</div>
  }

  if (!loading && !game) {
    return <div>No game found</div>
  }

  if (!game) {
    return null
  }

  return (
    <Layout loading={loading}>
      <div className={`w-full max-w-7xl ${gamePageStyles.container}`}>
        <ResultCard game={game} rounds={rounds} isLottoRoundPage />
        <LottoRoundScreen
          gameTitle={gameTitle}
          rulesContent={
            <div
              dangerouslySetInnerHTML={{
                __html: trans(i18n, game.translations, 'description'),
              }}
            />
          }
          rounds={createLottoCardForLottoRoundPage(game, rounds)}
        />
      </div>
    </Layout>
  )
}

export default LottoRoundsPage
